<div aria-hidden="true" class="back-icon-container" data-cy="go-back-arrow">
    <warema-icon-button
        class="back-icon"
        icon="arrowLeft"
        tabindex="0"
        [ariaLabel]="'BACK' | translate"
        [routerLink]="[routerLink()]"
    />
</div>

<div class="title" [routerLink]="[routerLink()]">
    {{ translationKey() | translate }}
</div>
